import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Grid, Icon, Table } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { cardSelector } from '../../../../ducks/gridCard';
import Number from '../../../../components/BaseComponents/Number';
import FormField from '../../../../components/BaseComponents';
import { SELECT_TYPE, NUMBER_TYPE } from '../../../../constants/columnTypes';


const EditField = ({ value, name, onChange, error = [] }) => {
    return (
        <>
            {name === 'palletTypeId' ? (
                <Grid.Column>
                    <FormField
                        name={name}
                        value={value}
                        error={error && error.includes('palletTypeId')}
                        source={'palletTypes'}
                        onChange={onChange}
                        key={'palletTypeId'}
                        type={SELECT_TYPE}
                        noLabel={true}
                        isRequired={true}
                        compact={true}
                    />
                </Grid.Column>
            ) : (
                <Grid.Column>
                  <FormField
                    value={value}
                    isInteger={false}
                    name={name}
                    onChange={onChange}
                    noLabel={true}
                    error={error && error.includes(name)}
                    isRequired={true}
                    type={NUMBER_TYPE}
                    size={'mini'}
                />
                </Grid.Column>
            )}
        </>
    );
};

const PalletTypes = ({ form, onChange, gridName, load, settings: baseSettings }) => {
    const { t } = useTranslation();
    let [palletTypes, setPalletTypes] = useState([...(form.palletTypes || [])]);
    let [indexEdit, setIndexEdit] = useState(null);
    let [error, setError] = useState([]);

    const card = useSelector(state => cardSelector(state));

    const columns = [
        { name: 'palletTypeId' },
        { name: 'boxesInLayer' },
        { name: 'countLayers' },
        { name: 'boxesInPallet' },
    ];
    useEffect(
        () => {
            setPalletTypes(form.palletTypes || []);
        },
        [form.palletTypes],
    );

    const editPalletTypes = palletTypes => {
        onChange(null, {
            name: 'palletTypes',
            value: palletTypes,
        })
    };

    const handleDeleteItem = index => {
        const newPalletType = palletTypes.filter((item, i) => i !== index);
        editPalletTypes(newPalletType);
    };

    const handleEditItem = index => {
        setIndexEdit(index);
    };

    const handleSaveItem = () => {
        editPalletTypes(palletTypes);
        setIndexEdit(null);
        setError([]);
    };

    const handleChangeField = (e, { name, value }) => {
        const newColumns = [...palletTypes];

        newColumns[indexEdit] = {
            ...palletTypes[indexEdit],
            [name]: value,
        };

        setPalletTypes(newColumns);
    };

    const handleCancelItem = index => {
        setPalletTypes([palletTypes]);
        setPalletTypes([...form.palletTypes]);
        setIndexEdit(null);
        setError(false);
    };

    const handleAddPalletType = () => {
        setPalletTypes([...palletTypes, {}]);
        setIndexEdit(palletTypes.length);
    };

    return (
        <Form className="tabs-card">
            <Grid>
                <Grid.Row>
                    <Grid.Column className="add-right-elements">
                        <Button disabled={indexEdit !== null} onClick={handleAddPalletType}>
                            {t('AddButton')}
                        </Button>
                    </Grid.Column>
                </Grid.Row>

                <Grid.Row className="padding-14">
                    <Table 
                    compact={true} size={'small'}>
                    
                        <Table.Header>
                            <Table.Row>
                                {columns.map(column => (
                                    <Table.HeaderCell key={column.name}>
                                        {t(column.name)}
                                    </Table.HeaderCell>
                                ))}
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {palletTypes ? palletTypes.map((row, index) => (
                                <Table.Row key={row.id}>
                                    {columns.map(column => (
                                        <>
                                            {index === indexEdit ?
                                                (<Table.Cell
                                                    key={`cell_${row.id}_${column.name}_${index}`}
                                                    width={'4'}
                                                >
                                                    <EditField
                                                        value={row[column.name]}
                                                        name={column.name}
                                                        error={error}
                                                        onChange={handleChangeField}
                                                    />
                                                </Table.Cell>
                                                )
                                                :
                                                (
                                                    <Table.Cell
                                                        key={`cell_${row.id}_${column.name}_${index}`}
                                                        width={'4'}
                                                    >
                                                        {(row[column.name] && row[column.name].name) ? t(row[column.name].name) : t(row[column.name])}
                                                    </Table.Cell>
                                                )}
                                        </>
                                    ))}
                                    <Table.Cell
                                        textAlign="right"
                                        className="table-action-buttons"
                                    >
                                        {index === indexEdit ? (
                                            <>
                                                <Button
                                                    icon
                                                    onClick={() => handleCancelItem(index)}
                                                >
                                                    <Icon name="undo alternate" />
                                                </Button>
                                                <Button
                                                    icon
                                                    onClick={() => handleSaveItem(index)}
                                                >
                                                    <Icon name="check" />
                                                </Button>
                                            </>
                                        ) : (
                                            <>
                                                <Button
                                                    disabled={indexEdit !== null}
                                                    icon
                                                    onClick={() => handleEditItem(index)}
                                                >
                                                    <Icon name="pencil alternate" />
                                                </Button>
                                                <Button
                                                    disabled={indexEdit !== null}
                                                    icon
                                                    onClick={() => handleDeleteItem(index)}
                                                >
                                                    <Icon name="trash alternate" />
                                                </Button>
                                            </>
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            ))
                                : null}
                        </Table.Body>
                    </Table>
                </Grid.Row>
            </Grid>
        </Form>
    );
};

export default PalletTypes;
